export const scrollToElement = (ref, scrollType = "smooth") => {
  window.scrollTo({
    top: ref.offsetTop,
    left: 0,
    behavior: scrollType,
  });
}